import { CompanyCodeEntity } from "../Company/CompanyCodeEntity"

export interface CollectionDetailEntity {

    id: number,
    invoiceNo?: string | null,
    paymentMode?: string | null,
    payOrderNo?: string | null,
    agentNo?: string | null,
    agentName?: string | null,
    payeeName?: string | null,
    bankCode?: string | null,
    payOrderAmount?: number | null,
    paymentAmount?: number | null,
    balance?: number | null,
    remark?: string | null,
    poExcessAmount?: number | null,
    actualPaymentMode?: string | null,
    payee?: string | null,
    draftInvoiceNos?: string | null,
    totalInvAmt?: number | null,
    creditCardNo?: string | null,
    payeeList: CompanyCodeEntity[],



    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_COLLECTION_DETAIL_ENTITY: CollectionDetailEntity = {
    id: 0,
    invoiceNo: null,
    paymentMode: null,
    payOrderNo: null,
    agentNo: null,
    agentName: null,
    payeeName: null,
    bankCode: null,
    payOrderAmount: null,
    paymentAmount: null,
    balance: null,
    remark: null,
    poExcessAmount: null,
    actualPaymentMode: null,
    payee: null,
    draftInvoiceNos: null,
    totalInvAmt: null,
    creditCardNo: null,
    payeeList: [],
}
